import { FieldInstruction } from 'containers/FormBuilder'
import FinanceManagerSelectField from 'form/fieldComponents/FinanceManagerSelectField'
import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

// Dropdown variant of the Finance Manager field for auto applications.
// Other asset types keep the freetype `financeManager` field.
export const financeManagerSelect: FieldInstruction<
    typeof FinanceManagerSelectField
> = {
    Component: FinanceManagerSelectField,
    config: {
        label: 'Finance Manager',
        validator: Yup.string().required(FIELD_REQUIRED),
    },
}
